import { Modal as RBModal } from 'react-bootstrap';
const componentPath = 'components/Modal/Modal';
import * as React from 'react';
import { IHaiModalFooter } from '../IModal';
import { ScreenInfoContext } from '@hai/ui-react';
import { ThemedComponent } from '@hai/ui-react/dist/ThemeContext';

const BaseModalFooter = (props: IHaiModalFooter) => {
  const { className = '', children, mobileAlignment = 'absolute', ...rest } = props;
  const screenInfoContext = React.useContext(ScreenInfoContext);

  return (
    <RBModal.Footer
      className={`HaiModalFooter ${className} ${screenInfoContext && `screen-${screenInfoContext.screenType}`} ${
        screenInfoContext ? mobileAlignment : ''
      }`}
      {...{ theme: 'argon' }}
      {...rest}
    >
      {props.children}
    </RBModal.Footer>
  );
};

const ModalFooter = (props: IHaiModalFooter) => ThemedComponent(BaseModalFooter, props, componentPath);

export default ModalFooter;
